import { useContext } from "react";
import UserProgressContext from "../contexts/UserProgressContext";

/**
 * Hook to get and manage user progress
 * @returns {Object} User progress data and functions
 */
export const useUserProgress = () => {
  const context = useContext(UserProgressContext);

  if (context === undefined) {
    throw new Error("useUserProgress must be used within a UserProgressProvider");
  }

  return context;
};
